import { combineReducers, createSlice } from '@reduxjs/toolkit';
import { normalize, schema } from 'normalizr';
import { ExchangeRateDto } from '../../../common/PricePrgClient';
import { createAsyncAction } from '../../../utils';

const namespaces = {
    exchangeRates: 'exchangeRates',
    externalPriceSource: 'externalPriceSource',
    selectedExternalPricelistIds: 'selectedExternalPricelistIds',
    externalPricelistPeriods: 'externalPricelistPeriods',
    externalPriceSelectedDate: 'externalPriceSelectedDate',
    externalPriceDialogs: 'externalPriceDialogs',
    isLoading: 'isLoading',
    showAllArticles: 'showAllArticles',
    isExporting: 'isExporting'
};

export const getExchangeRateKey = ({ currency, validFrom }: ExchangeRateDto) => `${currency}-${validFrom}`;
const exchangeRatesEntity = new schema.Entity<ExchangeRateDto>('exchangeRates', undefined, {
    idAttribute: getExchangeRateKey
});

export const fetchExchangeRates = createAsyncAction<void, ExchangeRateDto[]>(
    namespaces.exchangeRates,
    'fetchExchangeRates'
);

const externalPriceSlice = createSlice({
    name: namespaces.exchangeRates,
    initialState: {} as { [key: string]: ExchangeRateDto },
    reducers: {},
    extraReducers: builder =>
        builder.addCase(fetchExchangeRates.success, (state, action) => {
            const normalized = normalize(action.payload, [exchangeRatesEntity]);
            return normalized.entities.exchangeRates ?? {};
        })
});

export default combineReducers({
    exchangeRates: externalPriceSlice.reducer
});
